const Licence = () => {
  return <div>ライセンス</div>;
};

export default Licence;
